import {
  TableRowHeaderCell,
  TableRowHeaderCellDate,
  TableRowHeaderCellText,
} from './styles/TimesheetsTableHeaderCell.styled';
import {
  formatHeaderDate,
  formatHeaderDateMobile,
} from '../utils/fromatHeaderDate';
import { isSameDay } from '../utils/isSameDay';
import { MAX_ROWS } from 'src/tabs/constants/Timesheets.constants';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useContext } from 'react';

interface TimesheetsTableHeaderCellProps {
  title: string;
  index?: number;
  date?: string;
}
export const TimesheetsTableHeaderCell = ({
  title,
  index,
  date,
}: TimesheetsTableHeaderCellProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  return (
    <TableRowHeaderCell
      firstRow={index === 0}
      lastRow={index === MAX_ROWS}
      isToday={isSameDay(date, new Date())}
      isMobile={isMobile}
    >
      {isMobile ? (
        <>
          <TableRowHeaderCellDate
            firstRow={index === 0}
            lastRow={index === 8}
            isMobile={isMobile}
          >
            {formatHeaderDateMobile(date)}
          </TableRowHeaderCellDate>
          <TableRowHeaderCellText
            firstRow={index === 0}
            lastRow={index === MAX_ROWS}
            isMobile={isMobile}
          >
            {title}
          </TableRowHeaderCellText>
        </>
      ) : (
        <>
          <TableRowHeaderCellText
            firstRow={index === 0}
            lastRow={index === MAX_ROWS}
          >
            {title}
          </TableRowHeaderCellText>
          <TableRowHeaderCellDate
            firstRow={index === 0}
            lastRow={index === MAX_ROWS}
          >
            {formatHeaderDate(date)}
          </TableRowHeaderCellDate>
        </>
      )}
    </TableRowHeaderCell>
  );
};
